<script>
  import { onMount } from 'svelte';
  import jQuery from 'jquery';
  import 'iconify-icon';
  import { fade, fly } from 'svelte/transition';
  import Viewport from 'svelte-viewport-info';
  // import { saveSessionTrappe } from './Utils/saveSession';
  import { asnavigate } from './Utils/asnavigation.js';
  import {
    Router,
    Link,
    Route,
    useLocation,
    useNavigate,
  } from 'svelte-navigator';
  // const navigate = useNavigate();
  import RouteTransition from './RouteTransition.svelte';
  // import TransitionContainer from './TransitionContainer.svelte';
  // import GTM from './Utils/Gtm.svelte';
  import gtag from 'gtag';
  // import gtm from './Utils/Gtag.svelte';
  import GAnalytics from './Utils/Analytics.svelte';

  let gtm;
  onMount(() => {
    gtm = window.dataLayer = window.dataLayer || [];
    gtm.push({ 'gtm.start': new Date().getTime(), event: 'event gtm.js' });
  });

  import Paths from './Utils/Paths.svelte';
  import {
    resetTrappeOption,
    saveTrappeInSession,
    getTrappeInSession,
    trappeStoretoObj,
    linkToPdf,
  } from './Utils/saveInDb';

  import {
    alertReload,
    isPhone,
    currentLocation,
    pathTrappe,
    nomTrappe,
  } from './stores.js';

  import Header from './Components/Header.svelte';
  import Home from './Pages/Home.svelte';
  import Recaptcha from './Pages/Recaptcha.svelte';
  import LayoutPage from './LayoutPage.svelte';
  import Recapitulatif from './Recapitulatif.svelte';
  import Process from './Process.svelte';
  import Modal, { getModal } from './Components/Modal.svelte';
  import Contact from './Components/Contact.svelte';
  import Faq from './Faq/Faq.svelte';
  import Geoloc from './Geoloc/Geoloc.svelte';
  import TextesPopup from './Components/TextesPopup.svelte';
  // import { txtMentions, txtpdcc, txtpdc, txtcgu } from './Utils/txt';

  export let penvv;
  let displayBloc = 'mentions';

  if (penvv === 'production') {
    console.log = function () {};
  }

  const openText = (bloc) => {
    displayBloc = bloc;
    getModal('text').open();
  };

  let documentHeight = 0;
  let windowHeight = 0;
  let headerHeight = 0;
  let contactHeight = 0;

  onMount(async function () {
    documentHeight = jQuery(document).height();
    windowHeight = jQuery(window).height();
    headerHeight = jQuery('#header').height();
    // console.log(`documentHeight : ${documentHeight}`);
    // console.log(`windowHeight : ${windowHeight}`);
    // console.log(`headerheight : ${headerHeight}`);
    contactHeight = documentHeight - headerHeight;
    // console.log(`contactHeight : ${contactHeight}`);
    headerHeight += 'px';
    contactHeight += 'px';
  });

  // const resolve = useResolve();
  // $: console.log(`useResolve : ${resolve(path)}`);

  $: outerWidth = 0;
  $: innerWidth = 0;
  $: outerHeight = 0;
  $: innerHeight = 0;
  // $: console.log(`$alertReload ${$alertReload}`);
  $: {
    console.log(`$pathTrappe`);
    console.log($pathTrappe);
  }

  //getModal('text').open()

  // getModal('text').close();
  // function closeModal() {
  //   getModal('ral').close();
  // }

  let contactVisible = false;

  function handleToggle(event) {
    if (event.detail !== contactVisible) {
      document.body.classList.toggle('no-scroll', contactVisible);
    }
  }

  function beforeUnload(event) {
    console.log('beforeUnload : '.$alertReload);
    if ($alertReload) {
      event.preventDefault();
      event.returnValue = '';
      return '';
    }
  }

  window.saveSessionTrappe = (sessionTrappe) => {
    console.log(`sessionTrappe : ${sessionTrappe}`);
  };

  if (Viewport.Width < 768) $isPhone = true;

  window.asphone = (modalclass, setSelection, img) => {
    if (Viewport.Width < 768) window.open(img);
    else getModal(modalclass).open(setSelection);
    //}
  };

  window.getObjKey = (obj, value) => {
    return Object.keys(obj).find((key) => obj[key] === value);
  };

  const annee = new Date().getFullYear();

  // onMount(async function () {
  //   console.log('onMount App begin');
  //   // const rrr = await getTrappeInSession();
  //   // const rrr = getTrappeInSession();
  //   getTrappeInSession().done(function (data) {
  //     console.log(data);
  //     console.log('onMount App end');
  //   });

  //   $nomTrappe = 'frfrfrfr';

  //   // console.log(`getTrappeInSession`);
  //   // $sensOuverture = 'ddddddddd';
  //   // const ret = trappeStoretoObj();
  //   // console.log(ret);
  //   // console.log(`-----------`);
  //   // console.log(`fermeture ${$fermeture}`);
  //   // console.log(`dimLongueurIdFiche ${$dimLongueurIdFiche}`);
  // });

  // function toggleFaq() {
  //   // console.log(` toggleContact ${$contactIsOpen}`);
  //   const btnContact = document.querySelector('.as-btn-faq');
  //   // btnContact.classList.add('disabled');
  //   navigate('../faq');
  //   // if ($contactIsOpen) navigate(-1);
  //   // else navigate('../contact');
  // }
  import BtnFaqFooter from './Faq/BtnFaqFooter.svelte';
  import BtnFaq from './Faq/BtnFaq.svelte';
</script>

<!-- <Gtag /> -->
<GAnalytics />

<!-- on:beforeunload="{beforeUnload}"  -->
<svelte:window
  on:beforeunload="{beforeUnload}"
  bind:innerWidth="{innerWidth}"
  bind:outerWidth="{outerWidth}"
  bind:innerHeight="{innerHeight}"
  bind:outerHeight="{outerHeight}"
/>
<!-- <p>
  Inner Width: {innerWidth}
</p>
<p>
  Inner Height: {innerHeight}
</p>
<p>
  Outer Width: {outerWidth}
</p>
<p>
  Outer Height: {outerHeight}
</p> -->
<Modal id="text">
  <div class="as-modal-wrapper modal-content">
    <TextesPopup displayBloc="{displayBloc}" />
  </div>
</Modal>

<Router basepath="/">
  <Paths />
  <!-- <nav style="position:absolute;top:30px;right:15px;z-index:999999;opacity:.5;">
    <Link
      to="/"
      class="mr-2 mt-4 px-4 py-1 text-white text-opacity-75 rounded-full bg-white bg-opacity-25"
      >Accueil
    </Link>
  </nav> -->
  <Header />
  <main class="as-main">
    <!-- {#if contactVisible} -->
    <!-- in:fly="{{ y: -200, duration: 600 }}" -->
    <!-- in:fade out:fade -->
    <!-- <div in:fly="{{ y: -200, duration: 200 }}" out:fade> -->
    <!-- <div
        class="as-contact"
        style:--top="{headerHeight}"
        style:--height="{contactHeight}"
      >
        <Contact bind:contactVisible /> -->
    <!-- <div class="as-contact-content"></div> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- {/if} -->
    <Route> 
      <Home />
      <!-- <Geoloc /> -->
    </Route>

    <Route path="contact/" component="{Contact}" isOpen="true" />
    <Route path="faq/" component="{Faq}" isOpen="true" />
    <Route path="merci/" component="{Geoloc}" let:params />
    <Route path="distributeurs/" component="{Geoloc}"  />
    <Route path="distributeurs/testpro" component="{Geoloc}" isPro="true" />
    <Route path="LayoutPage/" component="{LayoutPage}" />
    <Route path="recapitulatif/*" component="{Recapitulatif}" />
    <Route path="LayoutPage/:id" let:params>
      <LayoutPage idFiche="{params.id}" idParam="{params.id}" />
    </Route>
    <Route path="process/">
      <Process processStatus="" processStep="" />
    </Route>
    <Route path="process/particulier/:step" let:params>
      <Process processStatus="particulier" processStep="{params.step}" />
    </Route>
    <Route path="process/professionnel/:step" let:params>
      <Process processStatus="professionnel" processStep="{params.step}" />
    </Route>
    <Route path="process/negociant/:step" let:params>
      <Process processStatus="negociant" processStep="{params.step}" />
    </Route>
    <!-- <Route path="LayoutPage" component="{LayoutPage}" /> -->
    <!-- <Route path="LayoutPage/*blogRoute" component={LayoutPage} /> -->
    <!-- <Route path="LayoutPage/*">
      <Route path="post/:id" component="{LayoutPage}" />
      <Route path="/" component="{LayoutPage}" />
    </Route> -->
    <Route path="asrecaptcha/" component="{Recaptcha}" />

    <Route path="process/">
      <Process processStatus="" processStep="" />
    </Route>
  </main>

  <section class="as-footer">
    <div class="as-container mx-auto text-white">
      <div>
        <div class="flex" style="padding:15px 0;">
          <div class=" flex-none col-left">
            <img
              src="./statics/logo-semin-groupe.png"
              alt="Semin groupe"
              style="max-width: 80px;"
            />
          </div>
          <div class="flex-1" style="padding:5px 15px;">
            <div style="font-size: 20px;line-height: 22px;">Ne ratez rien</div>
            <div>Suivez-nous sur les réseaux</div>
            <div class=" ">
              <div class="flex gap-x-4">
                <div>
                  <a href="https://www.facebook.com/SEMIN.SAS" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      ><path
                        d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                      ></path></svg
                    >
                  </a>
                </div>
                <div>
                  <a href="https://twitter.com/semin_sas" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      ><path
                        d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                      ></path></svg
                    >
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.instagram.com/seminfrance/?hl=fr"
                    target="_blank"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      ><path
                        d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                      ></path></svg
                    ></a
                  >
                </div>

                <div>
                  <a
                    href="https://www.linkedin.com/company/semin-sas"
                    target="_blank"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      ><path
                        d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                      ></path></svg
                    ></a
                  >
                </div>
                <div>
                  <a
                    href="https://www.youtube.com/channel/UCGQatMogz2Cymk1e6G3D6yQ/videos"
                    target="_blank"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      ><path
                        d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                      ></path></svg
                    ></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="copyright" style="">
          © {annee} SEMIN TOUS DROITS RÉSERVÉS -
          <span class="link" on:click="{() => openText('mentions')}"
            >Mentions légales
          </span>
          -
          <span class="link" on:click="{() => openText('pdc')}"
            >Politique de confidentialité
          </span>
          -
          <!-- <span class="link" on:click="{() => openText('cgu')}">CGU</span> - -->
          <span class="link" on:click="{() => openText('pdcc')}"
            >Politique de Confidentialité des cookies
          </span>
          -
          <BtnFaqFooter />

          <button
            style="color:#49535d"
            on:click="{() => {
              gtm.push({ event: 'GT event click', target: 'GT event button' });
            }}"
          >
            gt
          </button>
          <button
            style="color:#49535d"
            on:click="{() => {
              gtag('event', 'click', {
                event_category: 'GA event_category Button',
                event_label: 'GA event_label click',
                value: '1',
              });
            }}"
          >
            ga
          </button>
          <!-- <a href="faq" class="link as-btn-faq">FAQ</a> -->
        </div>
      </div>
    </div>
  </section>
</Router>

<style>
  .as-main {
    position: relative;
    /* display: flex;
    justify-content: center;
    align-items: center; */
  }
  /* .as-contact {
    z-index: 25;
    position: absolute;
    top: var(--top);
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--greyLight-1-neu);
    display: flex;
    justify-content: center;
    height: var(--height);
  } */

  .as-footer {
    background-color: #49535d;
  }
  .as-footer svg {
    width: 25px;
  }
  .as-footer svg path {
    fill: #fff;
  }
  .copyright {
    font-size: 16px;
    line-height: 80px;
    text-align: center;
  }
  .copyright .link {
    cursor: pointer;
  }
  .copyright .link:hover {
    border-bottom: 1px solid #fff;
  }
  /* .modal-content {
    font-family: 'introlight';
    font-size: 14px;
  }
  .modal-content strong {
    font-family: 'introblack';
  } */
  @media only screen and (max-width: 768px) {
    .as-footer {
      padding: 0 10px;
    }
    .copyright {
      line-height: 20px;
      padding: 15px 0;
    }
  }
</style>
